module.exports = __webpack_public_path__ + "static/media/dk.59a9d25f.svg";